function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Move_with_new_contract"
}, /*#__PURE__*/React.createElement("title", null, "VF_battery_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M283.5 35.4H248V0h-14.1v35.4h-35.5v14.2h35.5V85H248V49.6h35.5zM283.5 171.3l-50.8-50.8h-41.3V85H0v155.9h21.3v.4c0 20.9 14.2 35.1 35.8 35.1 20.8 0 34.9-14 35.1-35.4h99.3v.4c0 20.9 14.2 35.1 35.8 35.1 20.8 0 34.9-14 35.1-35.4h21.3v-69.8zM163 212.6H28.3v-99.2H163v99.2zm28.3-63.8h29.6l34.2 34.2v29.6h-63.8v-63.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84.4 198.4l36.1-44.3H99.2l7.7-26.5-36 44.2h21.2z"
}))));